{
  "actionbar.actions": "Dejanja",
  "actionbar.actionsAvailable": "Na voljo so dejanja.",
  "actionbar.clearSelection": "Počisti izbor",
  "actionbar.selected": "Izbrano: {count}",
  "actionbar.selectedAll": "Vsi izbrani",
  "button.pending": "v teku",
  "contextualhelp.help": "Pomoč",
  "contextualhelp.info": "Informacije",
  "dialog.alert": "Opozorilo",
  "dialog.dismiss": "Opusti",
  "dropzone.replaceMessage": "Spustite datoteko za zamenjavo",
  "inlinealert.informative": "Informacije",
  "inlinealert.negative": "Napaka",
  "inlinealert.notice": "Opozorilo",
  "inlinealert.positive": "Uspešno",
  "label.(optional)": "(opcijsko)",
  "label.(required)": "(obvezno)",
  "menu.moreActions": "Več možnosti",
  "picker.placeholder": "Izberite…",
  "slider.maximum": "Največji",
  "slider.minimum": "Najmanj",
  "table.loading": "Nalaganje...",
  "table.loadingMore": "Nalaganje več vsebine...",
  "table.resizeColumn": "Spremeni velikost stolpca",
  "table.sortAscending": "Razvrsti naraščajoče",
  "table.sortDescending": "Razvrsti padajoče",
  "tag.actions": "Dejanja",
  "tag.hideButtonLabel": "Prikaži manj",
  "tag.noTags": "Nič",
  "tag.showAllButtonLabel": "Prikaž vse ({tagCount, number})",
  "breadcrumbs.more": "Več elementov"
}